import React, {useState, useEffect} from "react";
import {API} from "../backend";
import BackToTop from "./BackToTop";
import Base from "./Base";
import Card from "./Card";
import { getProducts } from "./helper/coreapicalls";
import Menu from "./Menu";
import Slideshow from "./Slideshow";
import {FaFacebookF} from 'react-icons/fa';
import {FaFacebookMessenger} from 'react-icons/fa';
import {FaInstagram} from 'react-icons/fa';
import {FaHands} from 'react-icons/fa';


export default function Home() {
    const [products, setProducts] = useState([]);
    const [error, setError] = useState(false);

    const loadAllProduct = () => {
        getProducts().then( data => {
            if(data.error) {
                setError(data.error);
            } else {
                setProducts(data);
            }
        });
    }

    useEffect(() => {
        loadAllProduct();
    }, []);

    return(
       <div>
           <Menu />
            <Slideshow />
            <BackToTop />
            <div className="row m-0 text-center p-4">
            {products.map((product, index) => {
                return(
                    <div key={index} className="col-lg-3 col-md-6  mb-4">
                        <Card
                        product={product}
                        />
                    </div>
                );
            })}
            </div>
            <footer className="footer py-3">
				<div className="container-fluid contact-bg text-dark text-center py-3">
					<h4>Contact us from here!</h4>
                    <a target="_blank" href="https://www.facebook.com/sgcmsg">
                    <FaFacebookF className="Fb" target="_blank" style={{height: 30, width:30, margin:5}}/>
					</a>
                    <a target="_blank" href="https://www.m.me/sgcmsg">
                    <FaFacebookMessenger className="Msngr" target="_blank" style={{height: 30, width:30, margin:25}}/>
					</a>
                    <a className="btn btn-primary btn-lg" target="_blank" href="https://www.m.me/sgcmsg">Contact Us</a>
                    <a target="_blank" href="https://instagram.com/sastogiftcards">
                    <FaInstagram className="Insta" target="_blank" style={{height: 30, width:30, margin:25}}/>
					</a>
                    <a target="_blank" href="https://facebook.com/groups/sastogiftcards">
                    <FaHands className="Fbgroup" target="_blank" style={{height: 30, width:30, margin:5}}/>
					</a>
				</div>
				<div className="container">
					<div className="text-muted text-center text-dark">
						&copy; {new Date().getFullYear()} <span className="text-dark">Sasto Gift Cards</span> All right reserved
                    </div>
				</div>
			</footer>
       </div>
    );
}


